import { put, takeEvery } from "redux-saga/effects";

import lobbyService from "../../../../services/casino/lobby";
import {
  getProvidersStart,
  getProvidersSuccess,
  getProvidersFailure,
  getSubCategoryStart,
  getSubCategorySuccess,
  getSubCategoryFailure,
  getLobbyBannersStart,
  getLobbyBannersFailure,
  getLobbyBannersSuccess,
  getProvidersSearchStart,
  getProvidersSearchSuccess,
  getProvidersearchFailure
} from "../../../redux/casino/lobby/casinoLobby";
import { showErrorMessage } from "../../../redux/toast";

function* casinoLobbyWatcher() {
  yield takeEvery(
    [
      getProvidersStart.type,
      getSubCategoryStart.type,
      getProvidersSearchStart.type
    ],
    casinoLobbyWorker
  );
  yield takeEvery(getLobbyBannersStart.type, LobbyBannersWorker);
}

function* casinoLobbyWorker(action) {
  try {
    switch (action.type) {
      case getProvidersStart.type: {
        const { data, error } = yield lobbyService.getProviders(action.payload);
        if (!error) {
          yield put(getProvidersSuccess(data));
        }
        if (error) {
          yield put(showErrorMessage({ msg: error.message }));
          yield put(getProvidersFailure());
        }
        break;
      }
      case getProvidersSearchStart.type: {
        const { data, error } = yield lobbyService.getProviders(action.payload);
        if (!error) {
          yield put(getProvidersSearchSuccess(data));
        }
        if (error) {
          yield put(showErrorMessage({ msg: error.message }));
          yield put(getProvidersearchFailure());
        }
        break;
      }
      case getSubCategoryStart.type: {
        const { data, error } = yield lobbyService.getSubCategory();
        if (!error) {
          yield put(getSubCategorySuccess(data));
        }
        if (error) {
          yield put(showErrorMessage({ msg: error.message }));
          yield put(getSubCategoryFailure());
        }
        break;
      }

      default: {
        break;
      }
    }
  } catch (error) {
    switch (action.type) {
      case getProvidersStart.type: {
        yield put(getProvidersFailure());
        break;
      }
      case getSubCategoryStart.type: {
        yield put(getSubCategoryFailure());
        break;
      }

      default:
        break;
    }
    yield put(showErrorMessage({ msg: error.message }));
  }
}

function* LobbyBannersWorker(action) {
  try {
    const { data, error } = yield lobbyService.getBannersData(action.payload);
    if (!error) {
      yield put(
        getLobbyBannersSuccess({
          [action?.payload?.pageType]: data,
          pageType: action?.payload?.pageType
        })
      );
    }
    if (error) {
      yield put(getLobbyBannersFailure(error));
    }
  } catch (error) {
    yield put(getLobbyBannersFailure());
  }
}

export default casinoLobbyWatcher;
